// layout
import { Link } from "react-router-dom";
import LayoutLogin from "../Container/Layout/LayoutLogin";
// style
import styles from "../Styles/Authentication/Login.module.css"
// component
import { useContext, useEffect, useState } from "react";
import BtnBack from "../Components/Authentication/BtnBack";
import { Context } from "../Context/Context";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { OneTimePasswordSchema } from "../Components/Validations/Validation";
import { otp, verifyPhoneNumber } from "../Services/ContectService";
import { toast } from "react-toastify";


const Verification = () => {

    const [resend, setResend] = useState(false);
    const { json, phoneNum, setPhoneNum, numberconvert, setLoading } = useContext(Context);
    const content = json?.Verification;
    let navigate = useNavigate();

    const getOtpHandler = async () => {
        setLoading(true);
        try {
            const { status } = await otp({ "email_or_phone": numberconvert(phoneNum) });
            if (status === 200) {
                toast.success("کد تایید به شماره تلفن شما ارسال شد");
                setLoading(false);
            }
        } catch (error) {
            if (error?.response && error?.response?.status === 404) {
                toast.error(json.toast.login_2);
                setPhoneNum(null);
                setLoading(false);
                return navigate("/register");
            } else {
                toast.error(json.toast.err_1);
                setLoading(false);
            }
        }
    }

    const verifyPhoneNumberHandler = async (values) => {
        setLoading(true);
        try {
            const { status } = await verifyPhoneNumber({
                email_or_phone: numberconvert(phoneNum),
                code: numberconvert(values.code)
            });
            if (status === 200) {
                toast.success("حساب شما با موفقیت تایید شد");
                setPhoneNum(null);
                setLoading(false);
                return navigate("/login");
            }
        } catch (error) {
            if (error?.response?.status === 400) {
                toast.error(json.toast.login_7);
            } else {
                toast.error(json.toast.err_1);
            }
            setLoading(false);
        }
    }

    var i = 0;
    const timer = () => {
        if (i === 0) {
            i = 1;
            var elem = document.getElementById("myBar");
            var width = 1;
            var id = setInterval(frame, 600);
            function frame() {
                if (width >= 100) {
                    clearInterval(id);
                    i = 0;
                    setResend(true)
                } else {
                    width++;
                    elem.style.width = width + "%";
                }
            }
        }
    }

    useEffect(() => {
        if (phoneNum) {
            getOtpHandler();
            timer();
        } else {
            return navigate(-1);
        }
    }, []);

    return (
        <LayoutLogin>
            <div className={styles.formLogin}>
                <div className="d-flex flex-column align-items-center gap-3 mb-4">
                    <svg width="72" height="72" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M43 0.8125C34.6561 0.8125 26.4996 3.28675 19.5619 7.92238C12.6242 12.558 7.21692 19.1468 4.02385 26.8555C0.830779 34.5643 -0.00467408 43.0468 1.62314 51.2304C3.25095 59.4139 7.26893 66.931 13.169 72.8311C19.069 78.7311 26.5861 82.7491 34.7696 84.3769C42.9532 86.0047 51.4357 85.1692 59.1445 81.9762C66.8532 78.7831 73.442 73.3758 78.0776 66.4381C82.7133 59.5004 85.1875 51.3439 85.1875 43C85.1751 31.815 80.7264 21.0916 72.8174 13.1826C64.9084 5.27363 54.185 0.824907 43 0.8125ZM24.0821 69.7852C26.2581 66.8097 29.1053 64.3896 32.3924 62.7212C35.6795 61.0529 39.3138 60.1834 43 60.1834C46.6863 60.1834 50.3205 61.0529 53.6076 62.7212C56.8947 64.3896 59.7419 66.8097 61.918 69.7852C56.389 73.7062 49.7782 75.8124 43 75.8124C36.2218 75.8124 29.611 73.7062 24.0821 69.7852ZM32.0625 39.875C32.0625 37.7118 32.704 35.5971 33.9058 33.7985C35.1076 31.9998 36.8159 30.5979 38.8144 29.7701C40.813 28.9422 43.0121 28.7256 45.1338 29.1477C47.2555 29.5697 49.2044 30.6114 50.734 32.141C52.2636 33.6707 53.3053 35.6195 53.7274 37.7412C54.1494 39.8629 53.9328 42.062 53.1049 44.0606C52.2771 46.0592 50.8752 47.7674 49.0766 48.9692C47.2779 50.171 45.1632 50.8125 43 50.8125C40.0992 50.8125 37.3172 49.6602 35.266 47.609C33.2149 45.5578 32.0625 42.7758 32.0625 39.875ZM68.7813 63.2891C65.743 59.4247 61.8705 56.2973 57.4531 54.1406C60.2683 51.2898 62.1776 47.6701 62.9407 43.7369C63.7038 39.8037 63.2867 35.7326 61.7418 32.0359C60.1969 28.3392 57.5933 25.1818 54.2585 22.9612C50.9237 20.7405 47.0066 19.5556 43 19.5556C38.9935 19.5556 35.0764 20.7405 31.7416 22.9612C28.4067 25.1818 25.8031 28.3392 24.2582 32.0359C22.7134 35.7326 22.2963 39.8037 23.0594 43.7369C23.8225 47.6701 25.7317 51.2898 28.5469 54.1406C24.1296 56.2973 20.257 59.4247 17.2188 63.2891C13.4025 58.4514 11.0256 52.6369 10.36 46.5112C9.69439 40.3856 10.7671 34.1963 13.4552 28.6518C16.1434 23.1074 20.3383 18.4319 25.5599 15.1606C30.7816 11.8893 36.8188 10.1543 42.9805 10.1543C49.1422 10.1543 55.1794 11.8893 60.401 15.1606C65.6226 18.4319 69.8176 23.1074 72.5058 28.6518C75.1939 34.1963 76.2666 40.3856 75.601 46.5112C74.9354 52.6369 72.5584 58.4514 68.7422 63.2891H68.7813Z" fill="black" />
                    </svg>
                    <h3>{content?.title}</h3>
                </div>
                <div className={styles.messageBox}>
                    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.0001 0.0963745H3.02339C2.39119 0.0963745 1.78488 0.388327 1.33784 0.908006C0.890811 1.42769 0.639669 2.13252 0.639669 2.86746V25.0361C0.637765 25.5639 0.766701 26.081 1.01105 26.5258C1.25539 26.9705 1.6048 27.324 2.01746 27.544C2.33423 27.7164 2.67958 27.8062 3.02935 27.8072C3.58908 27.8055 4.13028 27.5739 4.55731 27.1532L4.57996 27.1311L8.26758 23.3735H24.0001C24.6323 23.3735 25.2386 23.0815 25.6857 22.5619C26.1327 22.0422 26.3839 21.3373 26.3839 20.6024V2.86746C26.3839 2.13252 26.1327 1.42769 25.6857 0.908006C25.2386 0.388327 24.6323 0.0963745 24.0001 0.0963745ZM23.5234 20.0482H8.0888C7.52763 20.0481 6.98444 20.2783 6.55487 20.698L6.53223 20.7202L3.50013 23.8085V3.42168H23.5234V20.0482ZM8.26758 8.96384C8.26758 8.52288 8.41826 8.09998 8.68648 7.78817C8.9547 7.47637 9.31849 7.30119 9.69781 7.30119H17.3257C17.705 7.30119 18.0688 7.47637 18.337 7.78817C18.6053 8.09998 18.7559 8.52288 18.7559 8.96384C18.7559 9.40481 18.6053 9.82771 18.337 10.1395C18.0688 10.4513 17.705 10.6265 17.3257 10.6265H9.69781C9.31849 10.6265 8.9547 10.4513 8.68648 10.1395C8.41826 9.82771 8.26758 9.40481 8.26758 8.96384ZM8.26758 14.506C8.26758 14.0651 8.41826 13.6421 8.68648 13.3303C8.9547 13.0185 9.31849 12.8434 9.69781 12.8434H17.3257C17.705 12.8434 18.0688 13.0185 18.337 13.3303C18.6053 13.6421 18.7559 14.0651 18.7559 14.506C18.7559 14.947 18.6053 15.3699 18.337 15.6817C18.0688 15.9935 17.705 16.1687 17.3257 16.1687H9.69781C9.31849 16.1687 8.9547 15.9935 8.68648 15.6817C8.41826 15.3699 8.26758 14.947 8.26758 14.506Z" fill="black" />
                    </svg>
                    {content?.message}
                </div>
                <Formik
                    initialValues={{
                        code: "",
                    }}
                    validationSchema={OneTimePasswordSchema}
                    onSubmit={(values) => {
                        verifyPhoneNumberHandler(values)
                    }}

                >
                    <Form className="w-100">
                        <div className="main-form-group mb-3">
                            <label htmlFor="" className="mian-label">{content?.inputGroup1.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="code"
                                    type="text"
                                    placeholder={content?.inputGroup1.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="code"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>

                        <button
                            className={resend ? "color-info d-dlex" : "color-info d-none"}
                            onClick={() => {
                                timer();
                                setResend(false);
                                getOtpHandler();
                            }}
                        >
                            {content?.btnResend}
                        </button>
                        <div className={resend ? "d-none" : "d-block"}>
                            <div className={styles.timerFarme}>
                                <div className={styles.timer} id="myBar"></div>
                            </div>
                        </div>


                        <div className={styles.formLoginBtns}>
                            <button className={styles.formLoginBtnActive}>{content?.btn1}</button>
                            <BtnBack text={content?.btn2} />
                        </div>

                    </Form>

                </Formik>

            </div>
        </LayoutLogin>
    );
}

export default Verification;